import React, { useContext } from 'react';
import { convertToDateMonthYear } from '../../utils/ABHelper';
import { ABContext } from '../../contexts/ABContext';

const ResultSection2 = () => {
    const abContext = useContext(ABContext);
    const { testData } = abContext

    const entry = (label: string, value: string) => {
        return (<div className="tw-w-[40%] tw-ms-4">
            <label className="tw-text-sm tw-text-[#6B778C] tw-font-semibold tw-block">{label}</label>
            <label className="tw-text-[#091E42] tw-text-sm">{value}</label>
        </div>)
    }

    return (
        <section>
            <div className="tw-mt-6 tw-bg-white tw-rounded-md tw-border tw-border-[#dadbdd] tw-p-2">
                <div className="tw-flex tw-items-center tw-justify-evenly">
                    {entry("Start Date", convertToDateMonthYear(testData?.started_at))}
                    {entry("End Date", convertToDateMonthYear(testData?.ended_at))}
                    {entry("Run Duration", `${testData?.analyzed_duration}/${Math.ceil(testData?.test_duration)}`)}
                    {entry("Created by", testData?.ownership?.username)}
                </div>
            </div>
        </section>
    );
}

export default ResultSection2;